var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import TranslationUtility from 'services/AirBaltic/TranslationUtility';
import { MapState } from 'store/decorators';
var PaymentFormDescription = /** @class */ (function (_super) {
    __extends(PaymentFormDescription, _super);
    function PaymentFormDescription() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PaymentFormDescription.prototype, "features", {
        get: function () {
            return this.bookingValidation.features;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentFormDescription.prototype, "formIntro", {
        get: function () {
            return TranslationUtility.splitByPlaceholder(this.$t('payments.bookingDescription.intro.text'), '%LINK%');
        },
        enumerable: false,
        configurable: true
    });
    PaymentFormDescription.prototype.navigateToList = function () {
        // paymentPageUrl is not defined in this component and comes from PaymentController
        window.location.href =
            // @ts-ignore
            typeof paymentPageUrl === 'undefined' ? '/en/payment' : paymentPageUrl;
    };
    __decorate([
        MapState('bookingValidation')
    ], PaymentFormDescription.prototype, "bookingValidation", void 0);
    PaymentFormDescription = __decorate([
        Component
    ], PaymentFormDescription);
    return PaymentFormDescription;
}(Vue));
export default PaymentFormDescription;
